import React from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { SectionTitle } from "../pages/VehicleInfoPage";

const OwnerOptions = ({ field, ...props }) => {
  const { name, value, onChange } = field;
  return (
    <FormControl component="fieldset" {...props}>
      <SectionTitle component="legend">How Many Past Owners? *</SectionTitle>
      <RadioGroup
        aria-label="position"
        name={name}
        value={value}
        onChange={onChange}
        row
      >
        <FormControlLabel
          value="single"
          control={<Radio color="primary" />}
          label="Single Owner"
          labelPlacement="end"
        />
        <FormControlLabel
          value="multiple"
          control={<Radio color="primary" />}
          label="Multiple Owners"
          labelPlacement="end"
        />
      </RadioGroup>
    </FormControl>
  );
};

export default OwnerOptions;
